const CACHE_TIMESTAMP_KEY = 'cache-timestamp';
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

export const setCacheTimestamp = () => {
  localStorage.setItem(CACHE_TIMESTAMP_KEY, Date.now());
};

export const isCacheExpired = () => {
  const timestamp = localStorage.getItem(CACHE_TIMESTAMP_KEY);
  if (!timestamp) return true;

  const currentTime = Date.now();
  return (currentTime - timestamp) > CACHE_DURATION;
};
